import React from 'react'
import {
    FaPhoneSquare, FaLink 
} from 'react-icons/fa'

import {
    Footer, Content, Logo, List, FootBar 
} from './styles'

import logo from '~/assets/images/logo.png'

export default function () {
    return (
        <Footer>
            <Content>
                <List>
                    <Logo>
                        <img src={logo} alt="" />
                    </Logo>

                    <p>Endereço:</p>
                    <p>Rua Boaventura da Silva, 999</p>
                    <p>Nazaré – Belém – Pará</p>
                    <br />
                    <p>Horário de Funcionamento:</p>
                    <p>Segunda a Sexta de 9h às 17h</p>
                </List>
                
                <List>
                    <h2>
                        <FaLink size={16} />
                        Links úteis
                    </h2>

                    <ul>
                        <li><a href="https://sindmepa.org.br/2020/04/nossas-acoes-na-pandemia/">Ações na pandemia</a></li>
                        <li><a href="https://sindmepa.org.br/categoria/informacao/documentos/">Documentos</a></li>
                        <li><a href="https://sindmepa.org.br/categoria/assembleia-geral/">Assembléia Geral</a></li>
                        <li><a href="https://sindmepa.org.br/categoria/informacao/sindmepa-informa/">SINDMEPA informa</a></li>
                    </ul>
                </List>

                <List>
                    <h2>
                        <FaPhoneSquare size={20} />
                        Informações de contato
                    </h2>

                    <ul>
                        <li><a href="sindmepa@gmail.com">sindmepa@gmail.com</a></li>
                        <li>(91) 3224-3096</li>
                    </ul>
                </List>
            </Content>

            <FootBar>
                <p>
                    &copy; 
                    {' '}
                    {new Date().getFullYear()}
                    {' '}
                    Sindicato dos Médicos do Pará, todos os direitos reservados
                </p>
            </FootBar>

        </Footer>
    )
}
